/**
 * 垂直拖拽动画
 */
import fvAnimation from './fvAnimation';

export default class fvVerticalDrag extends fvAnimation {
    constructor(shape) {
        super(shape, 'fvVerticalDrag');
        this.dragingFlag = 0;
        this.orgShapePt = {
            x: 0,
            y: 0
        };
        this.shapeY = 0;
        this.min = AsyncFunction('return ' + this.min);
        this.max = AsyncFunction('return ' + this.max);
        this.minMoveToValue = AsyncFunction('return ' + this.minMoveToValue);
        this.maxMoveToValue = AsyncFunction('return ' + this.maxMoveToValue);
        this.orgShapePt.y = this.shape.y;
    }

    async run(event, show, domObj) {
        //判断如果是数据库变量， 就不执行
        if(this.fvScript.system.$.dbCom.isDbVar(this.expression)) return;
        var minValue = await this.executionScript(this.min);
        var maxValue = await this.executionScript(this.max);
        var minMoveToValueValue = await this.executionScript(this.minMoveToValue);
        var maxMoveToValueValue = await this.executionScript(this.maxMoveToValue);
        let Y = event.clientY - parseFloat(domObj.style.height) / 2;
        let value_Y;
        if(minValue < maxValue) {
            value_Y = this.orgShapePt.y - Y;
            if(value_Y < minValue) {
                value_Y = minValue;
            } else if(value_Y > maxValue) {
                value_Y = maxValue;
            }
        } else if(minValue > maxValue) {
            value_Y = this.orgShapePt.y - parseFloat(minValue) - Y;
            if(-value_Y > minValue) {
                value_Y = minValue;
            } else if(-value_Y < maxValue) {
                value_Y = maxValue;
            }
        }
        Function(`${this.expression}='${Math.abs(value_Y)}'`)();

    }
}



// WEBPACK FOOTER //
// ./src/js/div/animationDiv/fvVerticalDrag.js